import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    // FIXED: Removed width constraints, using flex to center content
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-900 to-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-7xl mx-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;